import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ToastProvider } from './contexts/ToastContext';
import { ConfirmDialogProvider } from './components/ConfirmDialog';
import NotificationProvider from './components/NotificationModal';
import { router } from './router';
import './index.css';
import ThemeProvider from './contexts/ThemeContext.jsx';
import SashWidget from './components/sash/SashWidget';

// Only AuthProvider and ToastProvider wrap everything.
// JobProvider, CustomerProvider, CalendarDayNoteProvider, InstallerProvider
// are now mounted inside ProtectedRoute so they NEVER fire on public pages
// like /e/:token or /estimate/:token.
ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ThemeProvider>
    <AuthProvider>
      <ToastProvider>
        <ConfirmDialogProvider>
          <NotificationProvider>
            <RouterProvider router={router} />
            <SashWidget />
          </NotificationProvider>
        </ConfirmDialogProvider>
      </ToastProvider>
    </AuthProvider>
      </ThemeProvider>
  </React.StrictMode>
);